import { render, staticRenderFns } from "./QScoreCardRecruitingLeads.vue?vue&type=template&id=2b7a5b00&scoped=true&"
import script from "./QScoreCardRecruitingLeads.vue?vue&type=script&lang=js&"
export * from "./QScoreCardRecruitingLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a5b00",
  null
  
)

export default component.exports